<template>
    <div>
        <div class="ckeditor-custom">
            <label class="mb-1 text-lg d-flex align-items-center">
                Mô tả
            </label>
            <ckeditor :editor="editor" v-model="entry.description" :config="editorConfig"></ckeditor>
        </div>
    </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default {
    props: {
        value: Object,
    },
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {},
            entry: {
                description: ''
            },
        }
    },
    watch: {
        "entry.description": {
            handler: function () {
                this.$emit("update", {
                    ...this.value,
                    description: this.entry.description,
                });
            },
            deep: true,
        },
        "value.description": {
            handler: function () {
                this.entry.description = this.value.description;
            },
            deep: true,
        },
    },
    created() {
        this.entry = this.value;
    },
}
</script>

<style>
.ckeditor-custom .ck-content {
    height: 250px;
}
</style>